/** Shared MIME type constants — reference these instead of inlining string literals. */
export const MIME_TYPES = {
	svg: "image/svg+xml",
	pdf: "application/pdf",
	png: "image/png",
	octetStream: "application/octet-stream",
} as const;

export type MimeType = (typeof MIME_TYPES)[keyof typeof MIME_TYPES];
